export function channelReducer(state = {}, action) {
  if (action.type === 'SET_CHATTER_CHANNEL') {
    return {
      ...state,
      chatter: action.channel
    }
  } else {
    return state
  }
}
